/*
 * Decode Relay-style Global IDs.
 *
 * Django GraphQL relay nodes return IDs as base64("TypeName:<int>")
 * (e.g. "VGlja2V0VHlwZTo3NDQx" → "TicketType:7441"). Backend mutations
 * however accept the raw integer (`id: Int!`). This helper accepts either
 * format and returns the integer, or null if it can't be parsed.
 */
export function relayIdToInt(id: unknown): number | null {
    if (id == null) return null
    if (typeof id === 'number') return Number.isFinite(id) ? id : null
    const s = String(id)
    // Plain integer string?
    const direct = parseInt(s, 10)
    if (Number.isFinite(direct) && String(direct) === s) return direct
    // Try Relay base64 decode.
    try {
        const decoded = atob(s)
        const colonIdx = decoded.lastIndexOf(':')
        if (colonIdx >= 0) {
            const n = parseInt(decoded.slice(colonIdx + 1), 10)
            if (Number.isFinite(n)) return n
        }
    } catch {
        // not valid base64
    }
    return null
}
